import axios from 'axios';
import { getRuntimeConfig } from './config';

const api = axios.create(); // baseURL postavljamo dinamički

api.interceptors.request.use(async (config) => {
  const { baseUrl, token } = await getRuntimeConfig();
  config.baseURL = baseUrl;
   if (token) (config.headers as any).Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
